import { getConfig } from '@sortlist-frontend/config';
import { ImageSourceHelper } from '@sortlist-frontend/media';
import Image from 'next/image';

type Props = {
  title: string;
  subtitle: string;
  dataTestId?: string;
  primaryActions: React.ReactNode;
  secondaryActions?: React.ReactNode;
};

export const NoResultsTemplate = (props: Props) => {
  const { title, subtitle, dataTestId, primaryActions, secondaryActions } = props;
  const s3BucketUrl = getConfig().publicEnv.s3Bucket;
  const noFilterResultsImage = ImageSourceHelper.fromUrl(
    `${s3BucketUrl}/illustrations/longtails/filters-empty-state-2.webp`,
  );
  return (
    <div data-testid={dataTestId} className="flex flex-col items-center justify-center gap-y-4 py-48">
      <Image src={noFilterResultsImage} alt={title} width={400} height={232} />
      <div className="flex flex-col items-center">
        <h2 className="font-medium text-base text-center">{title}</h2>
        <p className="text-base text-center">{subtitle}</p>
      </div>
      {primaryActions}
      <div className="mt-4 text-secondary-500 text-xs">{secondaryActions}</div>
    </div>
  );
};
